import {useSelector} from 'react-redux';

import useDidUpdate from '../../../hooks/useDidUpdate';
import {setIsYapForceCheckRequest} from '../../../state/ducks/yapEncrypted';
import {makeSelectIsNetworkOnline} from '../../../state/selectors/global';
import {dispatch} from '../../../state/store';

const YapRequestStatusChecker = () => {
    const isNetworkOnline = useSelector(makeSelectIsNetworkOnline());

    useDidUpdate(() => {
        if (isNetworkOnline) {
            dispatch(setIsYapForceCheckRequest(true));
            dispatch(setIsYapForceCheckRequest(true, true));
        }
    }, [isNetworkOnline]);

    return null;
};

export default YapRequestStatusChecker;
